export default {"src":"/trader-new/_next/static/media/homeFooter.acd6c3a8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};